module.exports = __webpack_public_path__ + "static/media/register-client.47e97866.svg";